export interface IParsedMortgageTerm {
    years: number;
    months: number;
    isValid: boolean;
}

export const parseMortgageTerm = (input: string): IParsedMortgageTerm => {
    const text = input.trim().toLowerCase();
    if (text === "") {
        return { years: 0, months: 0, isValid: true };
    }

    const yearsRegex = /(\d+)\s*(?:y|year|years)/;
    const monthsRegex = /(\d+)\s*(?:m|month|months)/;

    const yearsMatch = text.match(yearsRegex);
    const monthsMatch = text.match(monthsRegex);

    let years = 0;
    let months = 0;
    let hasYears = false;
    let hasMonths = false;

    if (yearsMatch) {
        years = parseInt(yearsMatch[1], 10);
        hasYears = true;
    }
    if (monthsMatch) {
        months = parseInt(monthsMatch[1], 10);
        hasMonths = true;
    }

    if (!hasYears && !hasMonths && /^\d+$/.test(text)) {
        const val = parseInt(text, 10);
        if (val < 50) {
            years = val;
            hasYears = true;
        } else {
            months = val;
            hasMonths = true;
        }
    }

    if (!hasYears && !hasMonths) {
        return { years: 0, months: 0, isValid: false };
    }

    if (hasYears && hasMonths) {
        if (months > 11) {
            months = 11;
        }
    } else if (hasMonths && !hasYears) {
        years = Math.floor(months / 12);
        months = months % 12;
    }

    return { years, months, isValid: true };
};

export const formatMortgageTerm = (totalMonths: number | null): string => {
    if (totalMonths === null || totalMonths === 0) {
        return "";
    }
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    const parts: string[] = [];
    if (years > 0) {
        parts.push(`${years} ${years === 1 ? "year" : "years"}`);
    }
    if (months > 0) {
        parts.push(`${months} ${months === 1 ? "month" : "months"}`);
    }
    return parts.length > 0 ? parts.join(" ") : "0 months";
};
